<template>
    <b-table striped hover :items="items" :fields="fields" title="Group">
        <template slot="tools" slot-scope="row">
            <b-form-checkbox switch @change="assignGroup(row.item.id, assignments.includes(row.item.id))" :checked="assignments.includes(row.item.id)">
                Access Rights
            </b-form-checkbox>
        </template>
    </b-table>
</template>

<script>
    import axios from 'axios'
    import config from '@/config/config'

    export default {
        name: 'AssignGroup',
        props: ['bid'],
        data () {
            return {
                checked: true,
                items: [],
                assignments: [],
                fields: ['name', 'tools']
            }
        },
        methods: {
            getGroups: function () {
                axios.get(config.apiUrl() + 'ga/getGroups').then(response => {
                    this.items = response.data
                }, err => {
                    this.items = []
                })
            },
            getGroupAssignment: function() {
                axios.get(config.apiUrl() + 'ga/getGroupAssignments/' + this.bid).then(response => {
                    this.assignments = response.data
                }, err => {
                    this.assignments = []
                })
            },
            assignGroup: function (id, lastState) {
                let payload = {
                    p_id: this.bid,
                    g_id: id
                }
                if(lastState === false) {
                    axios.post(config.apiUrl() + 'ga/assignGroup', payload).then(response => {
                        //this.items = response.data
                    }, err => {
                        this.items = []
                    })
                } else {
                    axios.post(config.apiUrl() + 'ga/unassignGroup', payload).then(response => {
                        //this.items = response.data
                    }, err => {
                        this.items = []
                    })
                }
            }
        },
        beforeMount () {
            this.getGroups()
            this.getGroupAssignment()
        }
    }
</script>

<style scoped>

</style>
